import React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl-next';

import Button from '@atlaskit/button';

import { useButtonEventHandler } from '../hooks/analytics-handlers/useButtonEventHandler';

const i18n = defineMessages({
	ctaMaybeLater: {
		id: 'end-of-trial-payment-modals.cta.maybe-later',
		defaultMessage: 'Maybe later',
		description: 'Maybe later button text',
	},
});

export const MaybeLaterButton = ({ closeModal }: { closeModal: () => void }) => {
	const { eventHandler } = useButtonEventHandler();
	const handleClick = () => {
		eventHandler({
			actionSubjectId: 'endOfTrialComponent',
			userAction: 'maybeLater',
		});
		closeModal();
	};

	return (
		<Button appearance="subtle" onClick={handleClick}>
			<FormattedMessage {...i18n.ctaMaybeLater} />
		</Button>
	);
};
